// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__-jiIa","navlink":"sidebar_navlink__KMYP1"};